import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const route: VueRoute = {
  path: "/cabinet/tasks",
  action: async () => {
    const c = await import("./views/tasks.vue");
    return h(c.default);
  },
};

export default route;
